import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const Locksmith = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my locksmith business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps locksmith businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for locksmith businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most locksmith businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my locksmith business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like locksmith. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Locksmith - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Locksmith CRM", url: "/industries/locksmith" }
  ];

  const industryData = {
    name: 'Locksmith Service',
    title: 'Capture Emergency Lockout Calls 24/7 & Stop Losing Business',
    subtitle: 'Never miss an emergency lockout call, dispatch faster, and turn emergencies into repeat security upgrade clients',
    icon: '🔐',
    challenges: [
      'Missing emergency calls = losing customers to competitors',
      'Hard to dispatch jobs efficiently',
      'Clients never return after emergency service',
      'Difficult to follow up on security upgrades',
      'Phone rings constantly during jobs'
    ],
    solutions: [
      'Emergency call routing captures every lockout',
      'GPS dispatch optimization',
      'Automated follow-up on security upgrades',
      'Post-service nurture sequences',
      'Smart call management during jobs'
    ],
    features: [
      '24/7 emergency call capture',
      'GPS-based dispatch routing',
      'Automated quote system',
      'Security upgrade follow-ups',
      'Service history tracking',
      'Online booking for non-emergency jobs',
      'Review automation',
      'Mobile job management'
    ],
    results: [
      'Capture 100% of emergency calls',
      '30% convert to security upgrades',
      '45% faster dispatch times',
      '£6.2K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Locksmith UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for locksmith businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for locksmith UK, locksmith business software, locksmith customer management, locksmith lead generation UK"
        url="/industries/locksmith"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default Locksmith;